import { Link } from "@tanstack/react-router";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export const EMPLOYER_ACCESS_CTA_LABEL = "Get access through your employer";

type Props = { label?: string; className?: string; size?: "default" | "sm" | "lg"; variant?: "default" | "outline" | "secondary" };

/** Standard signed-out CTA after the employer-only pivot. */
export function EmployerAccessCTA({ label = EMPLOYER_ACCESS_CTA_LABEL, className, size = "lg", variant = "default" }: Props) {
  return (
    <Button asChild size={size} variant={variant} className={className}>
      <Link to="/request-access">
        <Building2 className="mr-2 h-4 w-4" aria-hidden />
        {label}
      </Link>
    </Button>
  );
}

export default EmployerAccessCTA;
